import angular from 'angular';

export default angular
    .module('application.scene.identity.scene.change-email', [])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('identity.change-email', {
        url: '/change-email?token'
    });

    $transitionsProvider.onStart({
        to: 'identity.change-email'
    }, (transition) => {
        const $state = transition.injector().get('$state');
        const profileService = transition.injector().get('profileService');
        const sessionService = transition.injector().get('sessionService');
        const navigationService = transition.injector().get('navigationService');
        const notificationService = transition.injector().get('notificationService');

        let { token } = transition.params() || {};

        if (token) {
            return profileService.changeEmailWithToken(token).then(() => {
                showNotification('Congratulations!', 'Your email address has been updated. For security reasons we invalidated your existing session. Please sign in again.', false);
                return sessionService.reload().then(redirect).catch(redirect);
            }, () => {
                showNotification('Update Failed', 'We were unable to update your email address. The link might be expired.', true);
                return redirect();
            });
        }

        return redirect();

        function showNotification(title, message, hide) {
            navigationService.onSuccess(() => {
                notificationService.showError(message, title, hide, 0);
            }, true);
        }

        function redirect() {
            return $state.target('identity.sign-in');
        }
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/change-email/index.js